import CovidScreeningMetadataLang from '@/lang/covid-screening-metadata/CovidScreeningMetadataLang';
import RegionMetadataLang from '@/lang/region/RegionLang';
import InputValidationAccessibilityLang from '@/lang/input-validation-accessibility/InputValidationAccessibilityLang';

export default {
    fr: {
        base: {
            home: 'Accueil',
            joinUs: 'Nous joindre',
            btnSubmit: 'Soumettre',
            btnSubmitAriaLabel: 'Soumettre et prendre le rendez-vous.',
            close: 'J\'ai compris',
            closeAriaLabel: 'Bouton J’ai compris. Appuyez sur Entrée pour fermer la fenêtre de dialogue.',
            delete: 'Supprimer',
            print: 'Imprimer',
            noData: 'Aucune données disponibles',
            continue: 'Suivant',
            previous: 'Précédent',
            cancel: 'Annuler',
            between: 'Entre',
            yes: 'Oui',
            no: 'Non',
            na: 'Ne s\'applique pas ou Je ne sais pas',
            iDontKnow: 'Je ne sais pas',
            noAnswer: 'Je prèfere ne pas répondre',
            choice: 'Veuillez choisir',
            timezone: 'Mon fuseau horaire : ',
            establishmentTimeZone: 'Fuseau horaire :',
            easternTime: 'Heure de l\'Est',
            atlanticTime: 'Heure de l\'Atlantique',
            zipCode: 'Code postal',
            male: 'Masculin',
            female: 'Féminin',
            undefined: 'Non défini',
            changeVaccineType: 'Changer de vaccin',
            backToResults: 'Rétour aux résultats',
            previousPage: 'Page précédente',
            distanceWarning: 'Les distances affichées sont calculées en ligne droite et non selon un itinéraire.',
            showMore: 'Plus de détails',
            showLess: 'Moins de détails',
            phonePrefix: 'Tel.',
            phoneMask: '(###) ### - ####',
            namMask: 'AAAA #### ####',
            dateMask: '####-##-##',
            shortPostalCodeMask: 'A#A',
            postalCodeMask: 'A#A #A#',
            faxPrefix: 'Fax.',
            gapMode: 'Mode GAP',
            errors: {
                requiredField: 'Le champ est requis',
                requiredFieldWithLabel: 'Le champ "{fieldLabel}" est requis',
                requiredFieldsErrorList: 'Liste des champs requis en erreur :',
                requiredFieldConsentForm: 'Le code de confirmation est obligatoire',
                requiredTermsAndConditions: 'Vous devez accepter les termes et conditions',
                requiredRecaptchaToken: 'Vous devez cocher la case "Je ne suis pas un robot"',
                failed: 'Une erreur est survenue. Veuillez réessayer.',
                requiredFields: 'Veuillez remplir tous les champs obligatoires',
                cellPhone2short: 'Le numéro du cellulaire est incorrect',
                phone2short: 'Le numéro de téléphone est incorrect',
                invalidEmail: 'Le format du courriel est invalide',
                invalidNam: 'Le numéro d\'assurance maladie est invalide',
                temporaryNAM: 'Le numéro d\'assurance maladie est un numéro temporaire',
                invalidUrl: 'Le format du lien Internet est invalide',
                invalidZipCode: 'Code postal invalide',
                invalidBirthday: 'La date de naissance est invalide',
                invalidDate: 'La date est invalide',
                invalidMonth: 'Le mois est invalide',
                invalidName: 'Ce nom est invalide',
                invalidComment: 'Les caractères spéciaux ne sont pas supportés',
                zipcodeError: 'Le code postal n\'a pu être localisé',
                geolocShortPostcodeFormat: 'Le format du code postal n\'est pas valide',
                invalidConfirmationCode: 'Le format du code de confirmation n\'est pas valide',
                errorDialogTitle: 'Une erreur est survenue',
                invalidEmployeeNumber: 'Le format du numéro d\'employé n\'est pas valide',
                formQuestion: 'Vous devez répondre à cette question en sélectionnant l\'une des options plus haut.',
                invalidExtension: 'Le poste est invalide',
                scannedRequestMaxSize: 'La taille limite de votre fichier ne doit pas dépasser 8 mégaoctets (MO)',
                invalidDateRange: 'La date doit être entre le {minDate} et le {maxDate}',
                travelInvalidDateRange: 'La date de départ du voyage doit être entre le {minDate} et le {maxDate}',
                dateFuture: 'La date doit être dans le future',
                travelDateFuture: 'La date de départ du voyage doit être dans le future',
                pregnancyDateFuture: 'La date d\'accouchement doit être dans le future',
                datePast: 'La date doit être dans le passée',
                invalidPrematureBirthWeeks: 'Le nombre de semaines doit être 1 et 32',
            },
            cookieConsent: {
                message: 'Ce site utilise des témoins (Cookies) afin de vous offrir la meilleure expérience possible. Pour plus d\'information, visitez notre: ',
                linkLabel: 'Politique de protection des renseignements personnels et confidentiels',
                buttonLabel: 'Ok',
                urlPath: '/confidentialite',
            },
            accessibility: {
                nextStep: 'Continuer à la prochaine étape',
            },
            selected: 'sélectionné',
            popup: {
                title: 'Message de l\'établissement',
                titleAriaLabel: 'Titre. Message de l\'établissement sélectionné',
            }
        },
        header: {
            logoDescription: 'Logo Clic Santé. Appuyez sur Entrée pour retourner à l’accueil.',
            accessibilitySkipToContentLink: 'Passer au contenu principal',
            accessibilityGoToCurrentStep: 'Passer à l\'étape courante',
            subtitle: 'Prise de rendez-vous en ligne',
            tabs: {
                takeAppt: 'Prendre un rendez-vous',
                reminder: 'Programmer un rappel',
                cancelAppt: 'Annuler un rendez-vous',
            },
            profile: {
                menu: {
                    myProfile: 'Mon Profil',
                    disconnect: 'DÉCONNEXION',
                },
                loginText: 'Se connecter',
                loggedText: 'Mon compte',
                createMyAccount: 'Créer mon compte',
            },
            clicsante: {
                title1: 'Réservez votre rendez-vous',
                title2: ' santé dès maintenant!',
                menu: {
                    takeAppt: 'Prendre un rendez-vous',
                    solution: 'Solution de prise de rendez-vous',
                    cancelAppt: 'Annuler un rendez-vous',
                    faq: 'FAQ',
                    join: 'Nous Joindre',
                    job: 'Offres d\'emploi',
                    terms: "Modalités et conditions d'utilisation",
                    policy: 'Politique de confidentialité',
                    cookiePolicy: 'Politique relative aux témoins de connexion',
                    locale: 'FR',
                },
            },
            logoutConfirmationModal: {
                title: 'Déconnexion de mon compte Clic Santé',
                text: 'Êtes-vous certain de vouloir vous déconnecter?',
                cancel: 'Annuler',
                logout: 'Oui, déconnectez-moi',
            },
        },
        footer: {
            website: 'Visiter notre site Web',
            trimoz: {
                depistage: 'depistage.clicsante.ca est un système de réservation de rendez-vous par Internet qui permet à la population d\'obtenir rapidement et sans déplacement un coupon de réservation de rendez-vous.',
                clicsante: 'clicsante.ca est un système de réservation de rendez-vous par Internet qui permet à la population d\'obtenir rapidement et sans déplacement un coupon de réservation de rendez-vous.',
                pharmaservices: 'Pharmaservices.ca est un système de réservation de rendez-vous par Internet qui permet à la population d\'obtenir rapidement et sans déplacement un coupon de réservation de rendez-vous.',
                pharmaprix: 'Seul(es) responsable(s) d\'exercer la pharmacie',
                uniprix: 'Les services en pharmacie présentés sur cette page vous sont offerts par les pharmaciens propriétaires affiliés à Uniprix. Les pharmaciens sont les seuls responsables de l’exercice de la pharmacie.',
                allRightsReserved: 'Tous droits réservés',
            },
            terms: {
                name: "Modalités et conditions d'utilisation",
                path: 'termes-et-conditions'
            },
            policy: {
                name: 'Politique de confidentialité',
                path: 'confidentialite'
            },
            cookiePolicy: {
                name: 'Politique relative aux témoins de connexion',
                path: 'politique-temoins-connexion'
            },
            clicsante: {
                mobileMenus: {
                    takeAppt: 'Prendre<br/>un RDV',
                    cancelAppt: 'Annuler<br/>un RDV',
                    loginText: 'Se connecter',
                    loggedText: 'Mon compte',
                },
            },
        },
        appt: {
            accessibility: {
                selectPlace: `Sélectionner %{placeName} localisé au %{address}.`,
                unknowPlaceAddress: 'unknow localisation',
                selectService: `Sélectionner %{serviceName}. Description du service: %{serviceDescription}`,
                unknowServiceDescription: 'Aucune description trouvée.',
                dateDescription: {
                    default: `Sélectionnez pour prendre un rendez-vous en date du %{date} pour le service %{serviceName}.`,
                    alternate: `Saisissez la date dans le format A A A A/M M/J J`,
                },
                timeDescription: {
                    default: `{time}. Non sélectionné. Option {index} sur {total}. Appuyez sur Entrée pour sélectionner.`,
                    alternate: `{time}. Non sélectionné. Option {index} sur {total}. Appuyez sur Entrée pour sélectionner.`,
                },
                timeDescriptionSelected: {
                    default: `{time}. Sélectionné. Option {index} sur {total}.`,
                },
                stepsIntroduction: {
                    default: 'Début des étapes de prise de rendez-vous%{serviceName} du %{establishmentName} %{selectedPlaceName} (%{establishmentType})%{formattedPlaceAddress}.',
                    serviceName: ' pour le service %{serviceName}',
                    formattedPlaceAddress: " à l'adresse %{formattedPlaceAddress}",
                },
                continueButtonLabel: 'Passer à la prochaine étape pour poursuivre la prise de rendez-vous en date du {0} à {1} pour le service {2}.',
                profileCompletionOption: 'Étape facultative: vous pouvez compléter la création de votre compte Clic Santé pour pré-remplir le formulaire d\'identification à chaque rendez-vous.',
                noAvailable: 'n\'y a plus',
                available: 'y a',
                availsCheck: 'Il {0} des rendez-vous disponibles pour le mois sélectionné {1}. {2}',
                availsForMonthPrev: 'Appuyez sur la touche tab pour continuer or appuyez sur la touche entrée pour aller au mois précédent {0}',
                availsForMonthNext: 'Appuyez sur la touche tab pour sélectionner une date dans le calendrier ou appuyez sur la touche entrée pour aller au mois suivant {0}',
                noAvailsForMonthNext: 'Appuyez sur la touche entrée pour aller au mois suivant {0}',
                fillFormA11yDirective: 'Afin de compléter le formulaire de prise de rendez-vous sans embûche, la navigation par la tabulation est recommandé. Appuyez sur TAB pour avancer d\'un élément à un autre. Appuyez sur SHIFT et TAB pour revenir vers l\'élément précédent. Pour les éléments à choix multiples, la navigation avec les flèches permet de passer d\'un choix à l\'autre. Appuyez sur le ENTRER ou ESPACE pour sélectionner le choix.',
                dropdown: 'Liste déroulante. Pour changer la sélection, ouvrez la liste avec entrer puis utilisez les flèches haut et bas de votre clavier'
            },
            docTitle: 'Prendre un rendez-vous',
            answerQuestions: 'Répondez aux questions',
            answeredQuestions: 'Questions',
            chooseService: 'Sélectionnez un service',
            chooseServiceSub: 'Veuillez choisir un service',
            answerServiceFilters: 'Répondez aux questions',
            answeredServiceFilters: 'Questions',
            zipCodeFilter: 'Veuillez entrer votre code postal',
            answeredZipCodeFilter: 'Code postal',
            enterZipCode: 'Entrez votre code postal: ',
            choosePlace: 'Sélectionnez le lieu',
            choosePlaceSub: 'Veuillez choisir un lieu',
            chooseMoment: 'Sélectionnez le moment',
            stepProgresss: 'Étape @num sur @total',
            currentStep: '{0} étapes pour réserver le rendez-vous. Vous êtes actuellement à l\'étape {1} {2}.',
            completedStep: 'Étape complétée',
            dataCollectionForm: 'Informations complémentaires',
            dataCollectionAriaDescription: 'Votre rendez-vous a bien été réservé. Cette étape est facultative et permet au professionnel de mieux préparer votre rendez-vous',
            at: ' à ',
            to: ' au ',
            details: 'Détails',
            full: 'Complet',
            previousMonth: 'Mois précédent',
            nextMonth: 'Mois suivant',
            chooseMomentSub: 'Veuillez choisir le moment de votre rendez-vous',
            chooseTime: 'Veuillez choisir l\'heure de votre rendez-vous',
            nominativeData: 'Complétez votre réservation',
            nominativeDataSub: 'Veuillez entrer vos informations',
            description: 'Description :',
            document: 'Voir le document d\'information du service',
            apptTime: 'Heure du rendez-vous',
            apptTimeTitle: 'Sélectionner l\'heure du rendez-vous',
            apptTimeTitleAriaLabel: 'Sélectionnez l’heure du rendez-vous. Vous n\'entendrez que les heures disponibles.',
            apptDateTitle: 'Sélectionner la date du rendez-vous',
            apptDateTitleAriaLabel: 'Sélectionnez la date du rendez-vous. Vous n\'entendrez que les dates disponibles.',
            loadingTimeSlotsAriaMessage: 'Chargement de l\'horaire en cours',
            noMetaToDisplay: 'Aucune donnée nominative requise...',
            duration: 'Durée :',
            minutes: ' minutes',
            price: 'Prix : ',
            feesWillApply: 'Des frais s\'appliqueront',
            priceOnDemand: 'Prix sur demande',
            freeOfCharges: 'Ce service est sans frais',
            upcoming: 'À venir',
            complete: 'Complet',
            selectMonth: 'Sélectionnez le mois',
            serviceAvailable: 'Service disponible',
            serviceNotAvailable: 'Pas de service disponible',
            topOfStepperForm: 'Début du formulaire multi-étapes',
            targetVaccine: 'La cible de vaccination recommandée pour votre enfant est du ',
            targetPregnancy: 'La période cible recommandée pour prendre votre rendez-vous est du ',
            scannedRequest: 'Prenez une photo en format JPG/PNG ou scannez votre demande au format PDF afin de l\'envoyer avec votre rendez-vous. Taille limite acceptée: 8 mégaoctets (MO)',
            skipNAM: 'Je confirme que je n\'ai pas de Numéro d\'assurance maladie du Québec. Je m\'assure de fournir l\'information complémentaire la plus juste possible pour qu\'on puisse m\'identifier correctement.',
            tooltips: {
                number: 'Vous pouvez prendre plus d\'un rendez-vous à la fois',
                time: 'Veuillez choisir l\'heure du rendez-vous',
                clickToSee: 'Cliquez pour voir les détails du service',
                clickToSeePlaceDetails: 'Cliquez pour voir l\'adresse du lieu',
                scannedRequest: 'Il est de votre responsabilité de s\'assurer de la qualité de l\'image soumise.<br /><br />Conseils pour prendre la photo:<br />- Placez la requête à plat sur une surface foncée et non réfléchissante<br />- Assurez-vous qu\'il y a suffisamment de lumière<br />- Assurez-vous que l\'image est nette et que toute l\'information apparaisse clairement<br /><br />Inspectez la qualité de l\'image avant de la soumettre.',
            },
            dayStatus: {
                availabilities: 'Disponibilités',
                toCome: 'À venir',
                complete: 'Complet',
                kidsAvailabilitiesInsideDelay: 'Période cible',
                kidsAvailabilitiesInsideTolerance: 'Période hors cible',
                kidsAvailabilitiesOutsideTolerance: 'Disponibilités en dehors de la tolérance',
            },
            notifications: {
                deleteSuccess: 'Le rendez-vous à été supprimé',
                addSuccess: 'Le rendez-vous a été ajouté avec succès',
                failed: 'Une erreur est survenue. Veuillez réessayer.',
                dataCollectionForm: 'Veuillez compléter les informations complémentaires qui seront consultées par votre pharmacien.ne avant votre consultation. Cela permet de valider votre éligibilité aux soins et d\'accélérer votre accès auprès du professionnel de la santé.'
            },
            placeholder: {
                email: 'Inscrire votre courriel',
                confirmEmail: 'Validation de votre courriel',
                cellphone: 'Inscrire votre numéro de téléphone cellulaire',
                firstName: 'Inscrire le prénom du patient',
                lastName: 'Inscrire le nom de famille du patient',
                phone: 'Inscrire votre numéro de téléphone',
                birthday: 'Inscrire la date de naissance du patient',
                requester_link_0: 'Moi-même',
                requester_link_1: 'Une autre personne ou pour un autre patient',
                requester_name: 'Entrez le nom de la personne qui complète la réservation',
                consentFormConfirmationCode: 'Veuillez saisir le code de confirmation de votre formulaire de consentement',
                address: 'Inscrire l\'adresse du patient incluant la rue, le numéro d\'appartement, la ville et le code postal',
                employeeNumber: 'Numéro unique qui vous identifie chez votre employeur',
                employerName: 'Entrez le nom de votre employeur',
                workLocation: 'Entrez le lieu de votre travail',
                jobTitle: 'Entrez le titre de votre emploi',
                employeeRegion: 'Entrez la région de l\'employeur (RSS)',
                employeeEstablishment: 'Entrez l\'établissement de l\'employeur',
                employeeCategory: 'Entrez la catégorie d\'employé',
            },
            hints: {
                cellphone: 'Entrez votre numéro de cellulaire si vous désirez recevoir des notifications par SMS (Des frais de messageries standard peuvent s\'appliquer)',
            },
            labels: {
                employerRegion: 'Region de l\'employeur',
            },
            errors: {
                apptDate: 'Vous devez saisir la date',
                apptTime: 'L\'heure du rendez-vous est obligatoire',
                phone: 'Le téléphone est requis',
                cellphone: 'Le téléphone cellulaire est requis',
                email: 'Le courriel est requis',
                confirmEmail: 'La confirmation du courriel est requise',
                emailValid: 'Le format du courriel est non valide',
                first_name: 'Le prénom est requis',
                last_name: 'Le nom est requis',
                birthday: 'La date de naissance est requise',
                birthdayValid: 'La date de naissance est non valide',
                sendByEmail: 'Le courriel est requis pour envoyer le message',
                sendBySMS: 'Le téléphone cellulaire est requis pour envoyer le SMS',
                invalidAppointmentCount: 'Vous dépassez le nombre de rendez-vous disponibles',
                atLeastOneRequired: 'Vous devez prendre au moins un rendez-vous',
                noAvailability: 'Il n\'y a plus de disponibilité pour la recherche effectuée',
                emailNoMatch: 'Les champs «Courriel» et «Confirmation du courriel» doivent être identiques',
                dynamicServiceFilters: 'Aucun service correspondant trouvé',
                pregnancy_dpa: 'La date prévue d\'accouchement est requise',
                optinNewServiceList: 'Veuillez entrer votre courriel pour recevoir nos notifications de service',
                comments: 'Les commentaires sont requis',
                resident_first_name: 'Le prénom du résident requis',
                resident_last_name: 'Le nom de famille du résident requis',
                resident_room_number: 'Numéro de chambre du résident requis',
                resident_birthday: 'Date de naissance du résident requise',
                scanned_request: 'Le document numérisé est requis',
                requester_link: 'Vous devez indiquer pour qui est le rendez-vous',
                requester_name: 'Vous devez entrer le nom de la personne qui effectue la réservation',
                travelerCount: 'Le nombre de voyageur doit être compris entre %min% et %max%',
                nam: 'Le champs est requis. Vous devez saisir un Numéro d\'assurance maladie du Québec valide ou Cocher la case si vous ne détenez pas de numéro d\'assurance maladie du Québec.',
            },
            ah635: {
                healthProblems: 'Avez-vous eu la COVID-19, des symptômes de la COVID-19 ou avez-vous remarqué un changement récent dans votre état de santé?',
                immunosuppression: 'Êtes-vous dans l’une des deux situations suivantes :' +
                    '<div class="pl-4 pb-0">A. Vous prenez des médicaments immunodépresseurs.' +
                    '<br/>B. Vous souffrez d\'une maladie qui affaiblit votre système immunitaire, comme un cancer.</div>',
                allergicReactions: 'Avez-vous déjà fait une réaction allergique ayant nécessité une visite à l’hôpital?',
                pregnancyQuestion: '<strong class="font-weight-black">Si vous êtes une femme,</strong> êtes-vous présentement enceinte?',
                bleedingDisorder: 'Avez-vous un problème de coagulation du sang ou prenez-vous des médicaments qui éclaircissent le sang?',
                immunization: 'Êtes-vous dans la situation suivante ' +
                    '<div class="pl-4 pb-0">A. Vous avez été hospitalisé et avez reçu un traitement contre la COVID dans les 90 derniers jours?</div>',
            },
            as624: {
                healthProblemsQuestion: 'Y-a-t-il des changements dans votre état de santé, par rapport à votre état habituel ?',
                immunosuppressionQuestion: 'Avez-vous un affaiblissement du système immunitaire en raison d’une maladie ou d’un médicament pris actuellement ?',
                allergicReactionsQuestion: 'Est-ce que l’<strong class="font-weight-black">une</strong> des situations suivantes s’applique à vous ?' +
                                '<br/>- Vous avez déjà eu une réaction allergique grave qui a nécessité des soins médicaux d’urgence' +
                                '<br/>- Vous avez déjà eu, après l’administration d’un vaccin, une réaction assez grave qui a nécessité une consultation médicale',
                bleedingDisorderQuestion: 'Avez-vous des troubles de la coagulation nécessitant un suivi médical ou la prise d’anticoagulants ?',
                hasBloodTransfusionQuestion: 'Avez-vous reçu une transfusion sanguine ou une injection d’immunoglobulines au cours des 11 derniers mois ?',
                pregnancyQuestion: '<strong class="font-weight-black">Si vous êtes une femme</strong>, êtes-vous enceinte ?',
                lessThanSixMonthsMotherTreatmentQuestion: 'Si le patient est un enfant âgé de moins de six mois, la mère a-t-elle pris, pendant la grossesse, un agent biologique (ex. : Enbrel, Remicade, Humira) pour le traitement d’une maladie auto-immune (ex. : maladie de Crohn, polyarthrite rhumatoïde, lupus ou psoriasis) ?',
            },
            priorityGroup: {
                healthWorker: 'Je suis un professionnel de la santé (incluant les stagiaires) d’une clinique privée',
                informalCaregiver: 'Je suis un proche aidant',
                childcareWorker: 'Je suis un travailleur dans un service éducatif à la petite enfance reconnu ou dans un service de garde d\'une école',
                essentialHealthWorker: 'Je suis un employé travaillant dans un milieu à risque identifié par la santé publique',
                chronicDisease: 'Je suis une personne atteinte d’une maladie chronique ou un problème de santé augmentant le risque de complications de la COVID-19',
                handicapped: 'Je suis une personne présentant une incapacité motrice, intellectuelle, de la parole, du langage, visuelle, auditive ou associée à d’autres sens ou un trouble du spectre de l’autisme.',
                handicappedAccompagnator: 'Je suis un proche aidant accompagnant une personne présentant une incapacité motrice, intellectuelle, de la parole, du langage, visuelle, auditive ou associée à d’autres sens ou un trouble du spectre de l’autisme.',
                pregnantWoman: 'Je suis enceinte.',
                dayCampWorker: 'Je suis un employé travaillant dans un camp de vacances ou dans un camp de jour',
                seniorsResidence: 'Je suis résident d’un CHSLD ou d’une résidence pour personnes âgées',
                publicHealthWorker: 'Je suis un travailleur de la santé et des services sociaux du réseau public ou du secteur privé',
                schoolWorker: 'Je suis un travailleur dans un milieu scolaire',
                astra45: 'Je suis une personne qui a reçu 2 doses d’Astra Zeneca ou de Covishield',
                nothing: 'Je fais partie du groupe d\'âge à vacciner',
                nothing12: 'Je suis une personne âgée de 12 ans et plus',
                nothing14: 'Je suis une personne âgée de 14 ans et plus',
                nothing18: 'Je suis une personne âgée de 18 ans et plus',
                nothing25: 'Je suis une personne âgée de 25 ans et plus',
                nothing30: 'Je suis une personne âgée de 30 ans et plus',
                nothing35: 'Je suis une personne âgée de 35 ans et plus',
                nothing40: 'Je suis une personne âgée de 40 ans et plus',
                nothing45: 'Je suis une personne âgée de 45 ans et plus',
                nothing50: 'Je suis une personne âgée de 50 ans et plus',
                nothing55: 'Je suis une personne âgée de 55 ans et plus',
                nothing60: 'Je suis une personne âgée de 60 ans et plus',
                nothing65: 'Je suis une personne âgée de 65 ans et plus',
                nothing70: 'Je suis une personne âgée de 70 ans et plus',
                nothing75: 'Je suis une personne âgée de 75 ans et plus',
                nothing80: 'Je suis une personne âgée de 80 ans et plus',
                requiresConsent: 'Je prends rendez-vous pour un enfant de 12 ou 13 ans',
                immunocompromised: 'Je suis une personne immunodéprimée ou dialysée.',
                rpa: 'Je suis une personne qui réside dans un CHSLD ou une résidence privée pour aînés.',
                title: 'Êtes-vous dans l\'une des situations suivantes :',
                hint: 'Assurez-vous de valider votre éligibilité si vous êtes un travailleur de la santé du secteur privé, un travailleur essentiel ou si vous êtes atteint d’une maladie chronique.',
                vaccineArn: 'J’ai reçu 2 doses d’Astra Zeneca ou de Covishield suivies d’un vaccin à ARN messager (Moderna ou Pfizer)',
                none: 'Aucune des suivantes précédentes ne s’applique à moi',
                genericVaccine: {
                    title: 'Cochez la catégorie qui s’applique à vous :',
                    ageGroupIdentified: 'Je suis une personne âgée de %MIN_AGE_FOR_BOOKING% ans et plus',
                    immunocompromised: 'Je suis une personne immunodéprimée âgée de 18 ans ou plus',
                },
            },
            influenza: {
                healthStatus: 'Est-ce que l’une des situations suivantes s\'applique à vous :' +
                    '<div class="pl-4 pb-0">A. Vous avez remarqué un changement récent dans votre état de santé.' +
                    '<br/>B. Vous souffrez d’asthme.' +
                    '<br/>C. Vous présentez des sécrétions nasales importantes.' +
                    '<br/>D. Vous prenez un médicament qui traite ou prévient les accidents vasculaires cérébraux qui surviennent en raison de caillots de sang.</div>',
                isImmunosuppressive: 'Êtes-vous dans l’une des deux situations suivantes :' +
                    '<div class="pl-4 pb-0">A. Vous prenez des médicaments immunodépresseurs.' +
                    '<br/>B. Vous souffrez d\'une maladie qui affaiblit votre système immunitaire, comme un cancer.',
                hasSevereReaction: 'Avez-vous déjà fait une réaction importante après avoir reçu un vaccin ou un autre produit ayant nécessité une visite à l’hôpital?</div>',
                isPregnant: 'Si vous êtes une femme, êtes-vous présentement enceinte?',
                receivedVaccineLastMonth: 'Avez-vous reçu un vaccin au cours du dernier mois?',
                hasImmunocompromisedContact: 'Êtes-vous en contact étroit avec une personne immunodéprimée?',
                peopleWhoLiveWithMe: 'Vivez-vous avec ?' +
                    '<div class="pl-4 pb-0">A. Un enfant de moins de 6 mois.' +
                    '<br/>B. Une personne de 75 ans et plus.' +
                    '<br/>C. Une femme enceinte au 2e ou 3e trimestre.' +
                    '<br/>D. Avec une personne atteinte d’une maladie chronique ?</div>',
                hasBloodTransfusion: 'Avez-vous reçu une transfusion sanguine ou des immunoglobulines au cours des 11 derniers mois?',
                receivedPneumococcalVaccine: 'Avez-vous déjà reçu un vaccin contre le pneumocoque ?',
                isHealthCareWorker: 'Êtes-vous un travailleur de la santé ?',
                receivedShinglesVaccine: 'Avez-vous déjà reçu un vaccin contre le zona ?',
            },
            vaccineApprehension: {
                title: 'Veuillez indiquer quelle situation s\'applique à vous : ',
                yes: 'J’ai des appréhensions face à la vaccination (exemple : j’ai peur des aiguilles)',
                no: 'Je n’ai pas d’appréhensions face à la vaccination',
            },
            coveredRamq: {
                title: 'Cochez la catégorie qui s’applique à vous :',
                child6MonthTo17Years: 'Enfant de 6 mois à 17 ans atteint de maladie chronique',
                adultChronicDisease: 'Adulte atteint de maladie chronique, incluant les femmes enceintes quelque soit le trimestre',
                pregnant: 'Femme enceinte au 2e et 3e trimestre (14e semaine et plus)',
                person75AndMore: 'Personne âgée de 75 ans et plus',
                child6MonthTo23Month: 'Enfant âgé entre 6 et 23 mois',
                person60To74: 'Personne âgée de 60 à 74 ans',
                caregiver: 'Aidant naturel ou personne qui habitant sous le même toit qu’un enfant de moins de 6 mois ou qu’une personne à risque élevé d\'hospitalisation ou de décès',
                healthCareWorker: 'Travailleur de la santé',
                none: 'Je ne sais pas ou aucune de ces catégories ne s’applique au patient',
            },
            civilStatusLabel: {
                single: 'Célibataire',
                divorced: 'Divorcé(e)',
                married: 'Marié(e)',
                'common-law': 'Conjoint(e) de fait',
                separated: 'Séparé(e)',
                widowed: 'Veuf(ve)',
            },
            coadminInjection: {
                title: 'Quels vaccins souhaitez-vous recevoir lors de votre rendez-vous?',
                option1: 'Vaccins contre la COVID-19 et la grippe',
                option2: 'Vaccin contre la COVID-19 uniquement',
                option3: 'Vaccin contre la grippe uniquement',
            },
            relationshipListLabel: {
                father2: 'Père2',
                friend: 'Ami(e)',
                other: 'Autre',
                'brother-in-law': 'Beau-frère',
                stepmother: 'Belle-mère',
                stepfather: 'Beau-père',
                'sister-in-law': 'Belle-soeur',
                joint: 'Conjoint(e)',
                daughter: 'Fille',
                son: 'Fils',
                brother: 'Frère',
                grandmother: 'Grand-mère',
                grandfather: 'Grand-père',
                mother: 'Mère',
                nephew: 'Neveu',
                niece: 'Nièce',
                'little-girl': 'Petite-fille',
                grandson: 'Petit-fils',
                dad: 'Père',
                sister: 'Soeur',
                mother2: 'Mère2',
            },
            establishment: {
                type: {
                    pharmacie: 'Pharmacie',
                    clinique_privee: 'Clinique privée',
                    etablissement_de_sante: 'Établissement de santé',
                    demo: 'démo',
                },
            },
        },
        coupon: {
            thanks: 'Merci d\'avoir pris un rendez-vous !',
            thanksAriaLabel: 'Confirmation de prise de rendez-vous. Votre numéro de confirmation est le {0}. Merci d\'avoir pris un rendez-vous ! Un récapitulatif du rendez-vous pris est disponible ci-dessous.',
            title: 'Confirmation de rendez-vous',
            number: 'Rendez-vous : ',
            service: 'Service : ',
            resource: 'Avec : ',
            date: 'Quand : ',
            hour: 'Heure : ',
            price: 'Prix : ',
            place: 'Lieu : ',
            address: 'Adresse : ',
            placeInstructions: 'Message important :',
            instructions: 'Consignes :',
            additionalInformation: 'Informations supplémentaires :',
            sendByEmail: 'Envoyer par courriel',
            sendBySMS: 'Envoyer par SMS',
            confirmEmail: 'Vous recevrez ce coupon de confirmation par courriel à',
            confirmSMS: 'Vous recevrez une confirmation par SMS au',
            reminderEmail: 'avant votre rendez-vous, vous recevrez un rappel par courriel à',
            reminderSMS: 'avant votre rendez-vous, un rappel par texto sera envoyé au',
            virtualReminder: ' avant le rendez-vous, vous recevrez un courriel qui contiendra l\'hyperlien pour rejoindre la salle d\'attente virtuelle.',
            smsSent: 'Le SMS a été envoyé',
            backToApptBooking: 'Retour à l\'Accueil',
            scannedRequest: 'Document numérisé :',
            totalApptBooked: 'Nombre de rendez-vous réservés :',
            nextApptBookNotif: 'Le {date}, vous receverez un rappel pour prendre un rendez-vous pour le service: {service}',
            cancelCouponTitle: 'Précédent rendez-vous annulé avec succès !',
            takeAnotherAppt: {
                title: 'Réserver un autre rendez-vous',
                text: 'Pour réserver un rendez-vous pour un accompagnateur ou un proche résidant au même lieu, cliquez sur ce bouton pour compléter la réservation rapidement.',
                btn: 'Prendre un autre rendez-vous',
            },
            createProfile: 'Créez un profil Clic Santé',
            whyCreateProfile: 'Pourquoi créer un profil ?',
        },
        profileAdvantage: {
            title: 'Bonifiez votre expérience : Créez votre profil Clic Santé !',
            subtitle: 'Profitez de plusieurs avantages exclusifs :',
            actionBtn: 'Créer un compte gratuitement',
            advantage1: 'Visualiser l’historique de vos rendez-vous passés',
            advantage2: 'Gardez un oeil sur vos rendez-vous à venir',
            advantage3: 'Modifiez vos données personnelles et coordonnées en un seul endroit',
        },
        reminder: {
            title: 'Programmer un rappel pour vos prochains rendez-vous',
            reminderInfo: 'Information sur le rappel',
            remindersInfo: 'Information sur les rappels',
            maxDate: 'Date maximale : ',
            addChild: 'Ajouter un rappel',
            submitSuccess: 'Rappels ajoutés avec succès',
        },
        cancel: {
            cancelTitle: 'Entrez votre numéro de confirmation dans la zone de texte suivante et cliquez sur le bouton "Annuler mon rendez-vous".',
            cancelSingleTitle: 'Informations sur votre rendez-vous :',
            cancelMultipleTitle: 'Nous avons détecté que les rendez-vous suivants ont été pris en même temps. Cochez les coupons que vous désirez annuler:',
            couponLostTitle: 'Vous avez perdu votre numéro de confirmation? Vous pouvez retrouver vos rendez-vous à venir à partir de votre courriel.',
            unableToCancel: 'Vous ne parvenez pas à annuler votre rendez-vous? Merci d\'appeler votre centre de santé afin d\'obtenir une assistance.',
            couponNumber: 'Numéro de coupon',
            appointmentDate: 'Date du rendez-vous',
            appointmentDateRequired: 'La date du rendez-vous est requise',
            groupUuidFromEmail: 'Numéro d\'identification',
            couponNumberRequired: 'Le numéro de coupon est requis',
            cancelMyAppointment: 'Annuler mon rendez-vous',
            cancelMyAppointments: 'Annuler mes rendez-vous',
            getMyAppointment: 'Envoyez-moi un rappel de mes rendez-vous',
            keepMyAppointments: 'Conserver mes rendez-vous',
            keepMyAppointment: 'Conserver mon rendez-vous',
            cancelSuccess: 'Rendez-vous annulé avec succès',
            couponLostSuccess: 'Courriel envoyé avec succès',
            couponLostSuccessNoContent: 'Aucun rendez-vous relié à ce courriel',
            errors: {
                invalidCouponNumber: 'Numéro de coupon invalide',
                appointmentDateInvalid: 'Date du rendez-vous invalide',
                couponNotAssociated: 'Aucun rendez-vous associé à ce coupon',
            },
            accessibility: {
                prefilledCouponNumber: 'Le numéro de coupon a été prérempli depuis votre courriel de rendez-vous',
                prefilledAppointmentDate: 'La date du rendez-vous a été préremplie depuis votre courriel de rendez-vous',
                apptToBeCancelled: 'Cliquez pour annuler le rendez-vous en date du {0} à {1} pour le service {2}.',
            },
        },
        confirm: {
            confirmSuccess: 'Rendez-vous confirmé avec succès',
        },
        joinUs: {
            title: 'Nous Joindre',
            byPhone: 'Par téléphone :',
            byMail: 'Par courriel : Veuillez remplir le formulaire ci-dessous',
            send: 'Envoyer',
        },
        form: {
            fieldIsRequired: 'Le champ {0} est requis',
            required: 'requis',
            optional: 'optionnel',
            ownerTermsText: '* Je comprends et accepte les <a href="{0}" target="_blank">Modalités et conditions d’utilisation</a> et confirme avoir {1} ans ou plus.',
            otherTermsText: '* Le patient (ou le tuteur si le patient a moins de {1} ans ou est inapte) comprend et accepte les <a href="{0}" target="_blank">Modalités et conditions d’utilisation</a>.',
            preTermsText: '* J\'ai  ans ou plus et j\'accepte les',
            prePolicyText: 'et la',
            terms: 'Termes et Conditions',
            policy: 'Politique de Protection des Renseignements Privés',
            termsLink: '/termes-et-conditions',
            policyLink: '/confidentialite',
            optinNewServiceList: 'Avertissez-moi lorsque de nouveaux services sont disponibles dans ma région',
            ownerConsentCollectData: '* Je comprends et accepte que mes renseignements personnels soient communiqués en conformité avec la <a href="{0}" target="_blank">Politique de confidentialité</a>.',
            otherConsentCollectData: '* Le patient (ou le tuteur si le patient a moins de 14 ans ou est inapte) comprend et accepte que ses renseignements personnels soient communiqués en conformité avec la <a href="{0}" target="_blank">Politique de confidentialité</a>.',
            ownerConsentReceiveMarketing: 'Je consens à recevoir des communications commerciales électroniques de la part de Trimoz par SMS et par courriel. Ces communications peuvent notamment inclure l’ajout de nouveaux services dans votre région. Je comprends que je peux me désabonner à tout moment.  Trimoz se réserve le droit d’envoyer des courriels opérationnels concernant leurs services.',
            otherConsentReceiveMarketing: 'Le patient consent à recevoir des communications commerciales électroniques de la part de Trimoz par SMS et par courriel. Ces communications peuvent notamment inclure l’ajout de nouveaux services dans votre région. Je comprends que je peux me désabonner à tout moment.  Trimoz se réserve le droit d’envoyer des courriels opérationnels concernant leurs services.',
            birthDate: 'Date de naissance du patient',
            vaccine: ' Vaccin',
            reminderDate: 'Date du rappel',
            firstName: 'Prénom du patient',
            lastName: 'Nom du patient',
            phone: 'Téléphone',
            email: 'Courriel',
            message: 'Votre message',
            age: 'Âge',
            status: 'Statut',
            ramq: 'RAMQ',
            adult: 'Adulte',
            child: 'Enfant',
            receiveSMSConfirmation: 'Recevoir la confirmation par SMS',
            selectNam: 'Choisir le patient',
            consentHints: {
                warning: 'SUIVEZ LES INSTRUCTIONS CI-DESSOUS JUSQU\'À LA FIN POUR OBTENIR VOTRE CODE DE CONFIRMATION DU FORMULAIRE DE CONSENTEMENT.',
                bullet1: '<strong class="font-weight-black"><a href="https://access.eforms.pharmaprix.ca/flu" target="_blank" class="consent-form-link"><span style="color: #cc0a00;">Remplir votre formulaire de consentement</span></a>.</strong> Le code vous sera envoyé par courriel ou message texte/SMS dès que vous aurez complété le formulaire.',
                bullet2: 'Utilisez le même numéro de téléphone dans votre demande de rendez-vous et lorsque vous remplissez le formulaire de consentement.',
                bullet3: 'Après avoir récupéré votre code de confirmation (courriel ou SMS), revenez dans cette fenêtre pour saisir le code dans le champ ci-dessus.',
                thanks: '<strong class="font-weight-black">Merci de remplir le formulaire. Cela nous permettra d’assurer votre sécurité lors de la réception de votre vaccin contre la grippe.</strong>',
            },
            delegatedPiConsent: '* Je confirme être autorisé légalement à fournir ces renseignements personnels ou avoir obtenu l\'autorisation de la personne concernée.',
            travelerCountHint: 'La configuration autorise exactement %traveler% voyageur(s) par rendez-vous',
            confirmEmail: 'Confirmation du courriel',
            multiApptLabel: 'Nombre de rendez-vous désiré',
            firstVirtualAppointment: 'Il s\'agit de mon premier rendez-vous virtuel',
            hasntVirtualAccount: 'Cliquer ici si vous n\'avez pas de compte Reacts',
            appointmentOnReacts: 'Le rendez-vous virtuel aura lieu sur la plateforme ',
            appointmentOnReacts2: '. Vous receverez par courriel les détails pour vous préparer au rendez-vous virtuel.',
            warningNamExpired: "Vous êtes sur le point de soumettre une carte d'assurance maladie expirée",
            virtualAccountSelect: {
                label: 'Choisissez l\'option pour votre compte Reacts',
                items: {
                    true: 'Je possède un compte Reacts',
                    false: 'Je ne possède pas de compte Reacts',
                },
            },
            reactsRegisterMailInfo: 'Un courriel vous sera envoyé par Reacts afin de compléter la création de votre compte.',
            covid195To11ConfirmConsentToVaccine: {
                title: 'CONSENTEMENT (DÉCISION) DU PARENT OU DU TUTEUR',
                text: '<p class="mb-2">Comme parent ou tuteur d\'un enfant de moins de 14 ans, vous devez prendre les décisions relatives à sa vaccination.</p>' +
                    '<p class="mb-2">Les explications vous permettant de prendre une décision éclairée vous ont été fournies et son disponible dans le courriel qui a été envoyé par l\'école de votre enfant.</p>' +
                    '<p class="mb-2">Lorsque vous donnez votre consentement, il s\'applique également à la deuxième dose du vaccin à ARN messager contre la COVID-19 (Pfizer) si applicable.</p>' +
                    '<p class="mb-2">Si votre enfant a déjà eu un test positif à la COVID-19, le vaccinateur décidera du nombre de doses requises après évaluation. Dans ce cas, il est possible qu\'une seule dose soit nécessaire.</p>' +
                    '<p class="mb-2"><strong>Indiquez si vous acceptez ou si vous refusez que votre enfant soit vacciné contre la COVID-19 avec le vaccin à ARN messager contre la COVID-19 (Pfizer).</strong></p>' +
                    '<p>À tout moment, vous pouvez modifier votre consentement. Pour modifier votre consentement, vous devez contacter le CISSS ou CIUSSS de votre région.</p>',
                refuse: 'JE REFUSE que mon enfant soit vacciné contre la COVID-19',
                refuseError: 'Vous devez consentir à la vaccination de votre enfant pour compléter la réservation.',
            },
            covid195To11ConfirmReadDocument: {
                label: 'J’ai pris connaissance du feuillet intitulé « ' +
                    '<a href="https://www.quebec.ca/sante/problemes-de-sante/a-z/coronavirus-2019/deroulement-vaccination-contre-la-covid-19/vaccination-jeunes" target="_blank">' +
                    'Vaccination contre la COVID-19 pour les jeunes âgés de 5 à 11 ans' +
                    '</a>» qui est fourni par le ministère de la Santé et des Services sociaux et déclare avoir bien ' +
                    'compris les renseignements qu’il contient et avoir obtenu les informations appropriées concernant' +
                    'les avantages et les risques reliés à la vaccination contre la COVID-19 ainsi que les risques de ' +
                    'ne pas se faire vacciner.',
            },
            patientSelector: {
                otherPatient: 'Autre patient',
            },
            errors: {
                piConsentRequired: 'Le consentement est requis',
                birthDate: 'La date de naissance du patient est requise',
                birthDateFormat: 'La date de naissance est invalide',
                dateFormat: 'La date est invalide',
                vaccine: 'Le vaccin est requis',
                reminderDate: 'La date du rappel est requise',
                reminderDateFormat: 'La date du rappel est invalide',
                email: 'Le courriel est requis',
                emailFormat: 'Le courriel est invalide ',
                firstName: 'Le prénom du patient est requis',
                lastName: 'Le nom de famille du patient est requis',
                phone: 'Le téléphone est requis',
                phoneFormat: 'Le téléphone est invalide',
                message: 'Le message est requis',
                virtual_account: 'Le courriel associé au compte Reacts est requis',
            },
            phxCovidScreeningReasonQuestion: 'Veuillez indiquer la raison du dépistage :',
            phxCovidExperiencingSymptomQuestion: 'Présentez-vous actuellement l’un ou l’autre des symptômes suivants ?',
            phxCovidAskedToGetAScreeningTestQuestion: 'Un médecin, un professionnel de la santé ou une autorité de santé publique vous a-t-il demandé de faire un test de dépistage ?',
            phxCovidTravelledAndAdvisedToQuarantineQuestion: ' Au cours des 14 derniers jours, avez-vous voyagé à l’extérieur du Canada ET été avisé de vous mettre en quarantaine conformément aux exigences <a target="_blank" href="%domain%">fédérales en matière de quarantaine</a>?',
            phxCovidReceivedPositiveExposureNotificationQuestion: 'Au cours des 14 derniers jours, avez-vous reçu une notification d’exposition par l’application <strong>Alerte COVID</strong> ou un avis d’un contact qui a testé positif? <br/>Si vous avez déjà fait un test PCR et que vous avez obtenu un résultat négatif, sélectionnez « Non ».',
            phxCovidReceivedPositivePcrTestQuestion: 'Avez-vous reçu un résultat <strong>positif</strong> au test PCR pour la COVID-19 au cours des 90 derniers jours?',
            phxCovidScreeningReason0: 'Voyage',
            phxCovidScreeningReason0Note: ' (Veuillez lire l\'énoncé dans l\'encadré gris ci-dessous)',
            phxCovidScreeningReason1: 'En guise de précaution, mais je confirme que je n’ai pas de symptômes',
            phxCovidScreeningReason2: 'Autres raisons, mais je confirme que je n’ai pas de symptômes',
            phxCovidScreeningReasonHint: 'Il est de la responsabilité du voyageur de vérifier les exigences en matière du type de test de dépistage de la COVID-19 avec les pays/états/provinces visités (incluant les escales) ainsi que la compagnie aérienne. Certaines exigences pour le transit sont applicables.',
            phxCovidExperiencingSymptom0: 'fièvre',
            phxCovidExperiencingSymptom1: 'perte soudaine de l’odorat sans congestion nasale (avec ou sans perte de goût)',
            phxCovidExperiencingSymptom2: 'grande fatigue',
            phxCovidExperiencingSymptom3: 'perte d’appétit importante',
            phxCovidExperiencingSymptom4: 'douleurs musculaires généralisées',
            phxCovidExperiencingSymptom5: 'mal de tête',
            phxCovidExperiencingSymptom6: 'toux (nouvelle ou aggravée)',
            phxCovidExperiencingSymptom7: 'essoufflement, difficulté à respirer',
            phxCovidExperiencingSymptom8: 'mal de gorge',
            phxCovidExperiencingSymptom9: 'écoulement nasal associé à un autre symptôme de la COVID-19',
            phxCovidExperiencingSymptom10: 'nausées',
            phxCovidExperiencingSymptom11: 'vomissements',
            phxCovidExperiencingSymptom12: 'diarrhée',
            phxCovidExperiencingSymptom13: 'maux de ventre',
            phxCovidContactWithCovid19PositivePersonHint: 'Si vous avez déjà fait un test PCR et que vous avez obtenu un résultat négatif, sélectionnez « Non ».',
            phxCovidScreeningConsentHint: 'Avant de procéder au test antigénique de dépistage rapide, il est important de comprendre les points suivants :',
            phxCovidScreeningConsentPoint1: 'L’utilisation de cette méthode de dépistage chez les personnes ne présentant pas de symptômes est indiquée par le manufacturier, bien que pas approuvée par Santé Canada.',
            phxCovidScreeningConsentPoint2: 'Une personne ne présentant pas de symptômes et ne rencontrant pas les critères pour passer un test PCR, pourra décider de passer ce type de test afin de rencontrer une exigence relative à un voyage ou en guise de précaution avant d\'ajouter des gens dans son cercle de contacts (pour revoir les situations où il est plutôt recommandé de <a target="_blank" href="%consentDomain%" data-testid="link1">faire un test de dépistage dans un centre de dépistage du gouvernement</a>).',
            phxCovidScreeningConsentPoint3: 'Le test de dépistage rapide des antigènes est différent du test PCR. Ce test de dépistage est moins sensible que le test PCR et fournit des résultats préliminaires en fonction de l’heure à laquelle il a été effectué.',
            phxCovidScreeningConsentPoint4: 'Un résultat négatif n’exclut pas une infection par la COVID-19.',
            phxCovidScreeningConsentPoint5: 'Si vous obtenez un résultat préliminaire positif à votre test de dépistage, vous devez vous isoler à domicile et suivre les instructions sur le <a target="_blank" href="%consentDomain%" data-testid="link2">site du gouvernement.</a>',
            phxCovidScreeningConsentLabel: 'En cochant cette case, je reconnais avoir lu et compris les informations ci-dessus.',
            phxCovidScreeningDetailsConsentHint: 'En donnant mon consentement, je confirme que :',
            phxCovidScreeningDetailsConsentPoint1: 'Les réponses qui ont été fournies aux questions d’évaluation sont véridiques au mieux de ma connaissance, et je reconnais que si l’une de ces réponses est fausse, je peux être tenu responsable de tout préjudice causé.',
            phxCovidScreeningDetailsConsentPoint2: 'J’accepte que les réponses fournies aux questions d’évaluation soient utilisées pour évaluer la nécessité d’un test de dépistage de la COVID-19; si l’on conclut qu’il n’y a pas lieu de faire passer un test de dépistage de la COVID-19, j’accepterai cette recommandation.',
            phxCovidScreeningDetailsConsentPoint3: 'Je suis conscient qu’aucune déclaration ni garantie n’est formulée quant au moment où le test de dépistage rapide des antigènes pour la COVID-19 est effectué. Aucune déclaration ou garantie n’est formulée stipulant qu’un résultat négatif au test de dépistage rapide des antigènes pour la COVID-19 entraînera mon admission ou l’admission de mon mandataire dans la juridiction où il souhaite se rendre.',
            phxCovidScreeningDetailsConsentLabel: 'En cochant cette case, je reconnais avoir lu et compris les informations ci-dessus et je donne mon consentement à recevoir le test antigénique de dépistage rapide de la COVID-19 effectué par un professionnel de la santé employé d\'un pharmacien propriétaire. <strong>Je reconnais et accepte qu\'un pharmacien propriétaire, Pharmaprix, ses sociétés affiliées, ses directeurs, ses dirigeants, ses employés, ou ses agents ne sauraient en aucun cas être tenus responsables des pertes entraînées par l’impossibilité que je sois admis ou que mon mandataire soit admis, ou d’être admis tardivement, dans la juridiction où il a l’intention de se rendre.</strong>',
            phxCovidAcceptRiskLabel: 'En cochant cette case, je reconnais avoir lu et compris les informations et j’accepte <a target="_blank" href="%consentDomain%">les limites et les risques associés au test rapide</a>. J’accepte que le pharmacien propriétaire, Pharmaprix Inc. ou Loblaw Inc. ne garantissent ni ne représentent l’exactitude, l’efficacité ou la pertinence du test rapide. Par la présente, j’accepte et reconnais ces limites du test rapide et je renonce à toute réclamation future contre le pharmacien propriétaire, Pharmaprix Inc. ou Loblaw Inc. concernant l’exactitude, l’efficacité et la pertinence du test rapide.',
            traveler: {
                title: 'Informations sur les voyageurs',
                cardTitle: 'Voyageur',
                label: 'Voyageur',
                firstName: 'Prénom',
                lastName: 'Nom',
            },
        },
        errorPage: {
            title: 'Prise de Rendez-vous en ligne',
            content: 'Une erreur s\'est produite, contacter votre administrateur pour l\'informer de la situation.',
        },
        notFound: {
            title: 'Page introuvable (Erreur 404)',
            content1: 'Nous sommes désolés. La recherche effectuée n’a pas pu être finalisée.',
            content2: 'Le lien que vous avez inscrit a été déplacé ou modifié.',
            thanks: 'Merci de votre compréhension.',
            linkToPortal: 'Retourner à l\'accueil',
        },
        sheddingPage: {
            title: 'La prise de rendez-vous est temporairement indisponible.',
            content1: 'Nous vous invitons à revenir dans quelques minutes.',
            thanks: 'Merci de votre compréhension.',
            team: 'L\'équipe de ClicSanté.',
        },
        appointmentBookedButErrorDisplayingCoupon: {
            title: 'Rendez-vous réservé mais...',
            message: '<p>Une erreur de communication est survenue lors de l\'affichage du coupon de votre rendez-vous. Il nous est impossible d\'afficher les détails de votre rendez-vous mais soyez assuré <strong>qu\'il est bien créé et réservé</strong>. Le numéro de rendez-vous est: {appointment_number}.</p><p>Merci <strong>DE NE PAS</strong> reprendre de copie de ce rendez-vous!</p>',
        },
        closestAvailsModal: {
            title: 'Votre sélection n\'est plus disponible',
            timeNoLongerAvail: 'L\'heure choisie n\'est plus disponible.',
            chooseAnotherAvail: 'Veuillez sélectionner une autre plage horaire : ',
            returnToCalendar: 'Si vous désirez plus de choix, veuillez retourner au calendrier. Notez que vos renseignements personnels seront sauvegardés.',
            noClosestAvail: 'Il n\'y a plus de disponibilité pour la journée que vous avez sélectionnée.',
            noClosestAvailGotoCalendar: 'Veuillez retourner au calendrier pour sélectionner une autre journée. Notez que vos renseignements personnels seront sauvegardés.',
            toCalendarBtn: 'Retourner au calendrier',
        },
        errors: {
            validation: {
                'invalid-start': {
                    'custom-validator-failure': {
                        title: 'Plage horaire indisponible',
                        message: 'La plage horaire que vous voulez n\'est pas disponible.<br /><br />' +
                            'Veuillez rafraichir la page pour obtenir des disponiblités à jour.',
                    },
                },
                birthday: {
                    min_age_to_book: {
                        title: 'Message important',
                        message: 'Vous ne répondez pas au critère d\'âge minimum requis pour prendre un rendez-vous.',

                    },
                    max_age_to_book: {
                        title: 'Message important',
                        message: 'Vous ne répondez pas au critère d\'âge maximum requis pour prendre un rendez-vous.',
                    },
                },
            },
            generic: {
                title: 'Erreur',
                message: 'Une erreur est survenue lors de l\'opération, veuillez recharger la page et réessayer.',
            },
            forms: {
                expiredToken: {
                    title: 'Erreur',
                    message: 'Le délai pour remplir le formulaire est expiré. Cependant, votre rendez-vous demeure réservé.',
                },
            },
            'service-unavailable': {
                'shedding-page': {
                    title: 'Prise de rendez-vous temporairement indisponible',
                    message: 'La prise de rendez-vous est temporairement fermée à cause d\'un fort achalandage. Veuillez revenir dans quelques minutes.',
                },
            },
            invalid: {
                nam: {
                    title: 'Erreur',
                    message: 'Le numéro d\'assurance maladie est invalide',
                },
            },
            cancel: {
                couponNotAssociated: {
                    title: 'Introuvable',
                    message: 'Aucun rendez-vous associé à ce coupon',
                },
                couponNotFound: {
                    title: 'Message important',
                    message: 'Une erreur est survenue. Votre rendez-vous n’a pu être identifié pour l’une des raisons suivantes :' +
                        '<ul class="error-list" style="list-style: disc inside; margin: 15px 0 15px 15px;">' +
                        '<li>Votre numéro de coupon est erroné</li>' +
                        '<li>Votre numéro de coupon ne correspond à aucun rendez-vous futur</li>' +
                        '<li>L\'opération de recherche a échouée</li>' +
                        '</ul>' +
                        'Pour plus d\'informations, veuillez contacter votre établissement de santé.',
                },
            },

            appointment: {
                forbidden_cancellation_date: {
                    title: 'Annulation du rendez-vous',
                    message: 'Impossible d\'annuler le rendez-vous, le rendez-vous doit être dans le futur.',
                },
                forbidden_cancellation_client_state: {
                    title: 'Annulation du rendez-vous',
                    message: 'Votre rendez-vous n\'a pas pu être annulé car il est marqué comme présent ou absent.',
                },
                unable_to_obtain_lock: {
                    title: 'Surcharge du système',
                    message: 'Une grande quantité de clients réservent leur rendez-vous présentement. Veuiller réessayer dans quelques minutes. <br><br>Nous sommes désolés pour les inconvénients.<br><br>L’équipe Clic Santé\n',
                },
                unavailable_availability: {
                    title: 'Oups...',
                    message: 'La date et l\'heure du rendez-vous que vous avez choisi n\'est plus disponible. Retournez au calendrier afin de choisir une nouvelle date et heure.',
                },
                forbidden_confirm_already_cancelled: {
                    title: 'Confirmation du rendez-vous',
                    message: 'Votre rendez-vous ne peut être confirmé car, selon nos registres, il est annulé.',
                },
                forbidden_confirm_past: {
                    title: 'Confirmation du rendez-vous',
                    message: 'Vous ne pouvez confirmer ce rendez-vous car la date est déjà passée.',
                },
            },
            appointments: {
                'duplicate-detected': {
                    title: 'Attention!',
                    message: 'Vous avez déjà réservé un rendez-vous pour ce service. Assurez-vous d’annuler le rendez-vous précédent avant de procéder à cette réservation. Merci!',
                },
            },
            reacts: {
                errors: {
                    title: 'Erreur de communication',
                    message: 'Une erreur de communication avec la plateforme de rendez-vous virtuelle est survenue. Veuillez communiquer avec votre établissement de santé.',
                },
            },
            request: {
                timeout: {
                    title: 'Délai expiré',
                    message: 'L\'opération tentée n\'a pû être résolu à temps par le serveur. Prenez note qu\'il se peut que l\'opération se soit quand même complétée en arrière plan. Rafraîchissez votre navigateur afin de valider le tout.',
                },
            },
            availabilities: {
                public: {
                    'nothing-for-day': {
                        title: 'Aucune disponibilité',
                        message: 'Aucune disponibilité trouvée pour la journée sélectionnée',
                    },
                },
            },
            recaptcha: {
                response: {
                    error: {
                        title: 'Recaptcha Erreur',
                        message: 'La validation du recaptcha a expiré, veuillez recharger la page et réessayer.',
                    },
                },
            },
            birthdayAndNamAreInvalid: {
                title: 'Erreur',
                message: 'Votre date de naissance ou votre numéro d\'assurance maladie est incorrect.',
            },
            validateMinAge: {
                title: 'Erreur',
                message: 'Vous n\'êtes pas encore autorisé à prendre votre rendez-vous.<br /><br />' +
                    'Vous avez sélectionné un service qui ne correspond pas à votre tranche d\'âge. Veuillez retourner à l\'accueil de <a href="https://portal3.clicsante.ca/">Clic Santé</a> et sélectionner le bon service.',
            },
            validateMinAgeApp: {
                title: 'Erreur',
                message: 'Conformément à la Politique de confidentialité, les renseignements personnels concernant un mineur de moins de 14 ans ne seront collectés auprès de celui-ci sans le consentement du titulaire de l\'autorité parentale ou du tuteur.<br /><br />Pour plus d\'information ou pour un accompagnement, veuillez contacter directement votre établissement de santé',
            },
            patient: {
                appointment: {
                    'cannot-link-patient-using-current-user': {
                        title: 'Error',
                        message: 'Assurez vous que vous êtes encore connecté à votre compte.',
                    },
                },
            },
            screening: {
                preferredCommunicationEmail: {
                    title: 'Message important',
                    message: 'Important ! Vous avez indiqué vouloir recevoir le résultat de votre prélèvement par courriel. Toutefois, l\'un ou les deux champs suivants sont incorrects :<br/><br/>' +
                        '<ul style="list-style: circle"><li>Le champ "Courriel" n\'a aucune entrée. Veuillez svp ajouter une adresse courriel.</li>' +
                        '<li>Le champ "Préférence de communication" est à "Appel téléphonique". Veuillez svp modifier pour "Courriel".</li></ul>',
                    error: 'Vous avez indiqué vouloir recevoir le résultat de votre prélèvement par courriel.',
                },
            },
        },
        metadataScreeningFeesAcknowledged: {
            label: '{0}Je comprends que je prends rendez-vous pour un service privé de dépistage offert en pharmacie et que des frais seront chargés sur place. Ce service diffère du programme de distribution gratuit d’autotests du gouvernement, et du test TAAN (PCR) offert gratuitement en centre de dépistage. Si vous avez des symptômes de la COVID-19, nous vous invitons à compléter l’auto évaluation des {1}.',
            linkText: 'symptômes',
        },
        metadataCovidScreeningEmailConsent: {
            label: 'J’ai lu la déclaration de consentement et JE CONSENS à ce que le centre de dépistage qui procédera à mon test de dépistage de la COVID-19 ou à celui de mon enfant de moins de 14 ans me transmette le résultat de test par courriel avec l’option, selon la préférence choisie, de recevoir ou non une notification par messagerie texte m’avisant de la transmission de celui-ci par courriel.',
        },
        metadataCovidScreeningSecurityConsent: {
            label: '{0}Je reconnais qu’en recevant le résultat de test par courriel avec l’option, ou non, de recevoir une notification par messagerie texte m’avisant de la réception du courriel, certaines de mes informations sortiront de la présente plateforme informatique sécurisée et pourront ne pas bénéficier des mêmes mesures de sécurité ou pourront être accessibles à d’autres personnes.{1}' +
                ' Je reconnais que si mon adresse courriel ou mon numéro de téléphone sont incorrects, mon résultat de test pourrait être transmis à une mauvaise adresse courriel et mes nom et prénom pourraient être transmis à un mauvais numéro de téléphone.{2}' +
                'En ne consentant pas à ce que le résultat de test soit transmis par courriel, je comprends que la transmission du résultat de test sera effectuée par téléphone.{3}' +
                'Pour plus d’informations, veuillez consulter la {4}.',
            linkText: 'Déclaration de consentement',
        },
        banner: {
            promptLogin: {
                ctaMessage: 'gratuitement au compte Clic Santé pour automatiquement pré-remplir le formulaire d\'identification à chaque rendez-vous',
                login: 'Connectez-vous',
                subscribe: 'inscrivez-vous',
                or: 'ou',
            },
            promptCompleteRegistration: {
                ctaMessage1: 'Afin de pré-remplir le formulaire de réservation, vous devez ',
                login: 'compléter la création de votre compte Clic Santé.',
                ctaMessage2: ' Vous pouvez également remplir le formulaire de réservation manuellement. <br /> Une fois votre compte complété, vouz pouvez ',
                getUpdatedPatients: 'rafraîchir le formulaire',
            },
        },
        covidScreeningMetadataLang: {
            ...CovidScreeningMetadataLang.fr,
        },
        regionMetadataLang: {
            ...RegionMetadataLang.fr,
        },
        coAdministrationFluCovid: {
            metadata: {
                flu: {
                    title: 'Je souhaite recevoir les vaccins contre la grippe (influenza) et la COVID-19 en même temps.',
                    description: 'Le vaccin contre la grippe est maintenant offert gratuitement à l’ensemble de la population. Pour plus d’information, consultez la page <a href="https://www.quebec.ca/sante/conseils-et-prevention/vaccination/programme-de-vaccination-contre-la-grippe" target="_blank">Vaccination</a>.',
                },
                covid: {
                    title: 'Je souhaite recevoir les vaccins contre la COVID-19  et la grippe (influenza) en même temps.',
                    description: 'Le vaccin contre la grippe est maintenant offert gratuitement à l’ensemble de la population. Pour plus d’information, consultez la page <a href="https://www.quebec.ca/sante/conseils-et-prevention/vaccination/programme-de-vaccination-contre-la-grippe" target="_blank">Vaccination</a>.',
                },
            },
            couponReminder: '<b class="font-weight-black">Rappel:</b> Vous avez choisi de recevoir le vaccin contre la <u>COVID-19</u> et le vaccin contre la <u>grippe</u>. Les deux vaccins seront administrés lors du même rendez-vous. Aucune autre action n\'est requise.',
        },
        accessibility: {
            popup: {
                closed: 'Fenêtre de dialogue fermée.'
            },
            loadingGeneric: 'Chargement du contenu',
            postalCode: 'Code postal. Champ de saisie. Vide. Écrivez votre code postal pour trouver un rendez-vous à proximité de chez vous.',
            postalCodeValue: 'Code postal. Champ de saisie. {0}.',
            postalCodeBtn: 'Bouton Rechercher. Appuyer sur Entrée pour filtrer les lieux selon le code postal',
            questionFilters: {
                presentation: '{0} questions obligatoires. Répondez à toutes les questions pour continuer.',
                question: 'Question {0} sur {1}. ',
                group: '2 options. Groupe de boutons.',
                buttonSelected: 'Bouton {0} sélectionné.',
                buttonNotSelected: 'Bouton {0}. Non sélectionné. Appuyez sur Entrée pour sélectionner.',
            },
            timeSlots: 'Sélectionnez l’heure du rendez-vous. Fuseau horaire. {timezone}. Vous n\'entendrez que les heures disponibles.',
            timeSlotsGroup: '{0} options. Groupe de boutons radio. Obligatoire.',
        },
        inputValidationAccessibilityLang: {
            ...InputValidationAccessibilityLang.fr,
        },
        privacy: {
            title: 'Confidentialité des données',
            text: 'Les informations que vous fournissez ici seront traitées de manière confidentielle et ne seront accessibles qu\'au personnel de votre pharmacie.'
        },
    },
};
